// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ProjectLabelSchema = z.object({
  project_id: z.number().int(),
  label_id: z.number().int(),
  budget: z.number(),
  required: z.boolean(),
  default: z.boolean(),
  updated_at: z.string().datetime(),
});
